module.exports = __webpack_public_path__ + "static/media/p4.6462e595.png";